import { getMfExposedModule } from '@im/ui-lib/mf-utils';
import { useBuildVars } from 'mf_core/config';
import { useEffect, useState } from 'react';

export const useChatbot = () => {
  const [chatbotModule, setChatbotModule] = useState<JSX.Element | null>(null);
  const { buildEnvironment } = useBuildVars();

  const conditionsMet =
    buildEnvironment === 'development' ||
    buildEnvironment === 'staging' ||
    buildEnvironment === 'stagingx' ||
    buildEnvironment === 'staging2';

  useEffect(() => {
    if (conditionsMet) {
      (async () => {
        const ChatbotComponents = await getMfExposedModule(
          'unifiedchat_ai_x4c_mf',
          'components'
        );

        setChatbotModule(ChatbotComponents.Chatbot);
      })();
    }
  }, [conditionsMet]);

  return { chatbotModule, conditionsMet };
};
